import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { ToastContainer } from './components/feature/Toast';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;